import { combineReducers } from '@reduxjs/toolkit'
import breadcrumbSlice from './slice/title'
import menuListSlice from './slice/menuList'
import userInfoSlice from './slice/userInfo'
import buttonListSlice from './slice/buttonList'

const rootReducer = combineReducers({
  breadcrumbSlice,
  menuListSlice,
  userInfoSlice,
  buttonListSlice
})
export default rootReducer
